<template>
<div>

    <div class="label">
        {{label}}
    </div>

    <div 
        class="chip_row"
        style="min-height: 50px"
    >

        <div class="chip_container">
            <v-chip
                v-for="(item, index) in items"
                style="margin-right: 5px; margin-bottom: 5px;"
                :key="index"
                :close="!read_only"
                v-on:click:close="onClickClose(item)"
            >
                {{item.text}}
            </v-chip>
        </div>

        <m-edit-menu
            v-if="!read_only && !only_menu_item_is_add"
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
         />

         <v-icon
            v-else-if="!read_only && only_menu_item_is_add"
            v-on:click="onClickAdd"
         >
            mdi-plus-circle-outline
         </v-icon>

    </div>

    <m-select-object-dialog
        :type="type"
        ref="select-object-dialog"
        v-on:ok="onAddItem"
    />

    
</div>
</template>

<script>
const _ = require('lodash');
export default {
    props: {

        label: {
            type: String,
            default: function () { return 'label'; }
        },

        dialog_title: {
            type: String,
            default: function () { return 'Edit'; }
        },

        type: {
            type: String,
            default: function() { return 'bulk_message'; },
        },

        value: {
            type: Array,
            default: function() { return []; }
        },

        read_only: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            menu_items: [
                { 'text': 'Add...', 'event':'add' },  
            ],

            items: [],
        }
    },

    mounted () {
        this.update();
    },

    methods: 
    {
        update()
        {
            if ( this.type == 'bulk_message' )
            {
                this.updateBulkMessage();
                return;
            }  

            if ( this.type == 'lists' )
            {
                this.updateLists();
                return;
            } 

            this.items = [];
        },

        updateBulkMessage()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/autocomplete/bulk_message',
            
                'params' : {
                        'bulk_message_id': this.value,
                    },
            
                'on_success': (data) => {
                        let items = [];

                        for ( let i = 0; i < data.results.length; i++ )
                        {
                            items.push({
                                'text': data.results[i].text,
                                'value': data.results[i].value,
                            });
                        }

                        this.items = items;
                    },
            
                'on_error': 'Unable to list bulk messages',
            });  
        },

        updateLists()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/autocomplete/lists',
            
                'params' : {
                        'list_id': this.value,
                    },
            
                'on_success': (data) => {
                        let items = [];

                        for ( let i = 0; i < data.results.length; i++ )
                        {
                            items.push({
                                'text': data.results[i].text,
                                'value': data.results[i].value,
                            });
                        }

                        this.items = items;
                    },
            
                'on_error': 'Unable to list lists',
            });  
        },

        onClickAdd()
        {
            this.onMenuAction({
                'text': 'add',
                'event': 'add'
            });
        },

        onMenuAction(menu_item)
        {
            if ( menu_item.event == 'add' )
            {
                this.$refs['select-object-dialog'].showDialog();
                return;
            }

            this.$emit(menu_item.event, menu_item);
        },

        onEdit() 
        {
           this.$refs['edit_dialog'].showDialog(this.value);
        },

        getLabel(item)
        {
            return item.text;
        },

        setValueFromDialog(new_value)
        {
            this.$emit('input',new_value);
        },

        onAddItem(item)
        {
            let new_value = _.cloneDeep(this.value);
            new_value.push(item);

            this.$emit('input', new_value);
        },

        onClickClose(item)
        {
            let new_value = [];

            for ( let i = 0; i < this.value.length; i++ )
            {
                if ( this.value[i] == item.value ) continue;
                new_value.push(this.value[i]);
            }

            this.$emit('input', new_value);
        },
    },

    computed: {
        only_menu_item_is_add() {
            return this.menu_items.length == 1 && this.menu_items[0].event == 'add';
        }
    },

    watch: {
        value(newValue, oldValue) {
            this.update();
        }
    },
}
</script>

<style lang="scss" scoped>
.label
{
    color: rgba(0,0,0,0.38);
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 400;
}

.chip_row
{
    display: flex;
}

.chip_container
{
    flex-grow: 1;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    padding-bottom: 5px;
    padding-top: 5px;
}

.edit_container
{
    flex-grow: 0;
}
</style>